import {
  AppBar,
  Avatar,
  Box,
  Button,
  Container,
  Divider,
  Drawer,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Skeleton,
  styled,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import {
  Menu as MenuIcon,
  Close as CloseIcon,
  Notifications as NotificationsIcon,
  Message as MessageIcon,
  Person as ProfileIcon,
  Bookmark as SavedIcon,
  Assignment as PostsAppliedIcon,
  ExitToApp as LogoutIcon,
} from "@mui/icons-material";
import new_logo from "../../assets/img/new_logo.svg";
import { useLocation, useNavigate } from "react-router-dom";
import useUserId from "hooks/useUserId";
import useFetchUser from "hooks/useFetchUser";
import colors from "colors/color";
import notification_icon from "../../assets/img/notification_icon.svg";
import message_icon from "../../assets/img/message_icon.svg";
import profile_icon from "../../assets/img/profile_icon.svg";
import saved_posts_icon from "../../assets/img/saved_posts_icon.svg";
import posts_applied_icon from "../../assets/img/posts_applied_icon.svg";
import logout_icon from "../../assets/img/logout_icon.svg";
//   import { useSignalingStore } from 'views/signalingStore';
//   import { parseJwt } from 'utils/jwtUtils';
import { COLORS } from "colors/color";
import useSignalingStore from "views/signalingStore";
import { useTranslation } from "react-i18next";
import { useNotification } from "../../context/NotificationContext";
import WebSocketStatus from "../WebSocketStatus";
import ProfileScoreCircle from "components/ProfileScoreCircle/ProfileScoreCircle";
import login_icon from "../../assets/img/login_icon.svg";
const MenuTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "18px",
  letterSpacing: "0%",
  color: colors.primary,
}));

function NewAppBar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [totalNotifications, setTotalNotifications] = useState(0);
  const [unreadNotifications, setUnreadNotifications] = useState([]);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const isNotificationPopoverOpen = Boolean(notificationAnchorEl);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const router = useLocation();
  const userId = useUserId();
  const userInfo = useFetchUser();
  // const userInfo = useMemo(() => useFetchUser(), []);
  const userRole = userInfo.formData.role;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    signalingServer,
    signalingServer2,
    addMessage,
    addNotification,
    notifications,
    notificationMessages,
    incrementNotification,
    clearNotifications,
    fetchUnreadNotifications: fetchUnreadNotificationsStore,
    markNotificationsAsRead,
    markNotificationAsRead,
    unreadNotifications: storeUnreadNotifications,
    notificationCounts,
    getTotalNotifications,
    messagenotification,
    clearMessageNotifications,
    removeMessageNotification,
    updateNotificationCount,
    setInitialNotificationCounts,
    addMessageNotification,
    initializeNotifications,
  } = useSignalingStore();

  const [notifMessage, setNotifMessage] = useState(0);

  // Get the notification functions from context
  const { setMessageSnackbar, setNotificationSnackbar } = useNotification();
  // useEffect(()=>{
  // console.log('useEffect::',userInfo.formData)
  // },[])
  // Initialize notifications when component mounts and set up periodic refresh
  useEffect(() => {
    if (userId.userId) {
      console.log("Initializing notifications for user:", userId.userId);
      // Store userId in localStorage for other components to use
      localStorage.setItem("userId", userId.userId);

      // Initial fetch
      initializeNotifications();

      // Set up periodic refresh
      const refreshInterval = setInterval(() => {
        console.log("Periodic notification refresh...");
        initializeNotifications();
      }, 30000); // Refresh every 30 seconds

      return () => {
        console.log("Cleaning up notification refresh interval");
        clearInterval(refreshInterval);
      };
    }
  }, [userId.userId, initializeNotifications]);

  useEffect(() => {
    console.log('notificationCounts : ', notificationCounts);
    console.log('messagenotification : ', messagenotification);
  }, [notificationCounts, messagenotification]);

  useEffect(() => {
    setTotalNotifications(getTotalNotifications());
  }, [notificationCounts, getTotalNotifications]);

  useEffect(() => {
    if (userId.userId) {
      fetchUnreadNotificationsStore();
    }
  }, [userId.userId, fetchUnreadNotificationsStore]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 800) {
        setIsVisible(false);
        return;
      }
      if (currentScrollY > 500) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  // Function to fetch user information including image
  const fetchUserInfoById = useCallback(async (userId) => {
    if (!userId) return null;

    try {
      const apiUrl = process.env.REACT_APP_API_URL || '';
      const response = await fetch(`${apiUrl}authentication/user_list/${userId}/`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch user info: ${response.status}`);
      }

      const userData = await response.json();
      console.log(`Fetched user info for ID ${userId}:`, userData);
      return userData;
    } catch (error) {
      console.error(`Error fetching user info for ID ${userId}:`, error);
      return null;
    }
  }, []);

  // Handle general notifications - DISABLED: Now handled by WebSocketManager
  // This was causing duplicate message handling and interfering with proper notification display
  /*
  useEffect(() => {
    if (signalingServer) {
      signalingServer.onmessage = async (event) => {
        try {
          const message = JSON.parse(event.data);
          console.log("AppBar received notification:", message);

          // Skip message-related notifications in this handler
          if (message.type === "notif_from_messages" || message.type === "chat_message") {
            return;
          }

          if (message.type === "notif") {
            const displayedNotifications = JSON.parse(localStorage.getItem('displayedNotifications')) || {
              notifications: [],
              messages: []
            };

            const notificationId = message.id || Date.now();
            if (!displayedNotifications.notifications.includes(notificationId)) {
              let senderInfo = null;
              if (message.sender_id) {
                senderInfo = await fetchUserInfoById(message.sender_id);
              }

              const newNotification = {
                id: notificationId,
                content: message.notif,
                timestamp: new Date().toISOString(),
                link: message.link,
                read: false,
                sender_id: message.sender_id,
                sender_name: message.sender_name || 'System',
                sender_image: (senderInfo && senderInfo.image) || message.sender_image || null,
                silent: false
              };

              addNotification(newNotification);

              setNotificationSnackbar({
                open: true,
                message: message.notif,
                link: message.link,
                id: notificationId,
                sender_image: (senderInfo && senderInfo.image) || message.sender_image || null,
                sender_name: message.sender_name || 'System'
              });

              displayedNotifications.notifications.push(notificationId);
              localStorage.setItem('displayedNotifications', JSON.stringify(displayedNotifications));
            }
          }
        } catch (error) {
          console.error("Error processing WebSocket notification:", error);
        }
      };
    }
  }, [signalingServer, addNotification, setNotificationSnackbar, fetchUserInfoById]);
  */

  // Handle message notifications - DISABLED: Now handled by WebSocketManager
  // This was causing duplicate message handling and interfering with proper notification display
  /*
  useEffect(() => {
    if (signalingServer2) {
      signalingServer2.onmessage = async (event) => {
        try {
          const message = JSON.parse(event.data);
          console.log("AppBar received message:", message);

          // Only handle message-related notifications, not chat messages
          // Chat messages are handled by WebSocketManager
          if (message.type !== "notif_from_messages") {
            return;
          }

          const displayedNotifications = JSON.parse(localStorage.getItem('displayedNotifications')) || {
            notifications: [],
            messages: []
          };

          const messageId = message.id || `appbar_msg_${message.sender_id}_${Date.now()}`;
          console.log('Message ID in AppBar:', messageId);

          // Check if this message was already processed
          if (!displayedNotifications.messages.includes(messageId)) {
            let senderInfo = null;
            if (message.sender_id) {
              senderInfo = await fetchUserInfoById(message.sender_id);
            }

            const messageData = {
              id: messageId,
              sender_id: message.sender_id,
              sender_name: message.sender_name || "New message",
              sender_image: (senderInfo && senderInfo.image) || message.sender_image || null,
              content: message.message || message.notif || "New message",
              message: message.message || message.notif || "",
              timestamp: message.timestamp || new Date().toISOString(),
              read: false,
              silent: false,
              type: message.type
            };

            // Only add if not already exists in store
            addMessageNotification(messageData);

            setMessageSnackbar({
              open: true,
              message: messageData.content,
              sender: messageData.sender_name,
              senderId: messageData.sender_id,
              senderImage: messageData.sender_image
            });

            displayedNotifications.messages.push(messageId);
            localStorage.setItem('displayedNotifications', JSON.stringify(displayedNotifications));
          }
        } catch (error) {
          console.error("Error processing WebSocket message:", error);
        }
      };
    }
  }, [signalingServer2, addMessageNotification, setMessageSnackbar, fetchUserInfoById]);
  */

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (action) => {
    console.log("Action:", action);
    if (action === "notifications") {
      setNotifMessage(0);
      navigate("/notifications");
    }
    if (action === "messages") {
      if (userRole === "r") {
        navigate("/talent/chat");
      }
      else {
        navigate("/chat");
      }
    }
    if (action === "profile") {
      navigate("/profile");
    }
    if (action === "talent_profile") {
      navigate("/talent/user-page");
    }
    if (action === "saved") {
      navigate("/saved_posts");
    }
    if (action === "applied") {
      navigate("/post_applied");
    }
    if (action === "logout") {
      localStorage.clear();
      // This will do both navigation and hard refresh
      window.location.href = "/landing";
    }
    handleClose();
  };

  const handleNotificationClick = (event) => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setNotificationAnchorEl(null);
    markNotificationsAsRead();
  };

  const handleNotificationItemClick = (event, notification) => {
    markNotificationAsRead(notification.id);
    handleNotificationClose();
    if (notification.link) {
      navigate(notification.link);
    }
  };

  // Reusable notification badge component
  const NotificationBadge = ({ count, color = "#0017E7" }) => (
    <Box
      sx={{
        ml: "auto",
        backgroundColor: color,
        color: "white",
        borderRadius: "50%",
        width: 20,
        height: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 11,
        fontWeight: "bold",
      }}
    >
      {count}
    </Box>
  );

  const MobileMenu = () => (
    <Drawer
      anchor="right"
      open={mobileMenuOpen}
      onClose={toggleMobileMenu}
      PaperProps={{
        sx: { width: "280px" },
      }}
    >
      <Box
        sx={{ p: 2, height: "100%", display: "flex", flexDirection: "column" }}
      >
        {/* Header with close button */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <img src={new_logo} alt="Logo" style={{ height: "32px" }} />
          <IconButton onClick={toggleMobileMenu}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* User info section (if logged in) */}
        {userId.userId && userInfo && (
          <Box
            sx={{
              mb: 3,
              p: 2,
              backgroundColor: "#F8F8F8",
              borderRadius: "12px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box sx={{ position: "relative" }}>
                <Avatar
                  sx={{
                    border: "1px solid #0017E7",
                    width: 48,
                    height: 48,
                  }}
                >
                  {userInfo.formData.image ? (
                    <img
                      src={userInfo.formData.image}
                      alt="User"
                      style={{ width: "100%", height: "100%" }}
                    />
                  ) : (
                    userInfo.formData.first_name?.charAt(0)
                  )}
                </Avatar>
                {/* Red dot indicator for unread notifications */}
                {(storeUnreadNotifications.length > 0 ||
                  messagenotification.length > 0) && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: -2,
                        right: -2,
                        width: 12,
                        height: 12,
                        backgroundColor: "#FF0000",
                        borderRadius: "50%",
                        border: "2px solid white",
                        zIndex: 2,
                      }}
                    />
                  )}
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    fontSize: "14px",
                    color: colors.primary,
                  }}
                >
                  {userInfo.formData.first_name} {userInfo.formData.last_name}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: "#666",
                  }}
                >
                  {userRole === "r" ? "Recruiter" : "Talent"}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}

        {/* Navigation Links */}
        <List sx={{ flexGrow: 1 }}>
          {[
            { path: "/landing", label: t("navBar.home") },
            { path: "/jobs", label: t("navBar.jobs") },
            { path: "/spontaneous", label: t("navBar.spontaneous") },
            { path: "/blogs", label: t("navBar.blog") },
            //  { path: "/joincaravan", label: t("navBar.carnavals") },
            // { path: "/", label: t("navBar.help_center") },
          ].map((item) => (
            <ListItem
              key={item.path}
              button
              onClick={() => {
                navigate(item.path);
                toggleMobileMenu();
              }}
              sx={{
                borderRadius: "8px",
                mb: 1,
                backgroundColor:
                  router.pathname === item.path
                    ? "rgba(0, 23, 231, 0.08)"
                    : "transparent",
                "&:hover": { backgroundColor: "rgba(0, 23, 231, 0.04)" },
              }}
            >
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontFamily: "Poppins",
                  fontWeight: router.pathname === item.path ? 600 : 400,
                  color: router.pathname === item.path ? "#0017E7" : "inherit",
                }}
              />
            </ListItem>
          ))}

          {/* Recruiter Space Button (if user is recruiter) */}
          {userRole === "r" && (
            <ListItem sx={{ px: 0, mt: 2 }}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  navigate("/talent/dashboard", { state: { recruiter: true } });
                  toggleMobileMenu();
                }}
                sx={{
                  backgroundColor: "#0017E7",
                  color: "white",
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  borderRadius: "10px",
                  padding: "12px 16px",
                  textTransform: "none",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#000DAD",
                    boxShadow: "0px 4px 10px rgba(0, 23, 231, 0.25)",
                  },
                }}
              >
                {t("navBar.recruiter_space")}
              </Button>
            </ListItem>
          )}

          {/* Super Admin Space Button (if user is super admin) */}
          {userRole === "s" && (
            <ListItem sx={{ px: 0, mt: 2 }}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  navigate("/superadmin/dashboard");
                  toggleMobileMenu();
                }}
                sx={{
                  backgroundColor: "#0017E7",
                  color: "white",
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  borderRadius: "10px",
                  padding: "12px 16px",
                  textTransform: "none",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#000DAD",
                    boxShadow: "0px 4px 10px rgba(0, 23, 231, 0.25)",
                  },
                }}
              >
                {t("navBar.super_admin_space")}
              </Button>
            </ListItem>
          )}

          {/* User Menu Items (if logged in) */}
          {userId.userId && (
            <>
              <Divider sx={{ my: 2 }} />

              {/* Notifications (hidden for recruiters) */}
              {userRole !== "r" && (
                <ListItem
                  button
                  onClick={() => {
                    handleMenuItemClick("notifications");
                    toggleMobileMenu();
                  }}
                  sx={{
                    borderRadius: "8px",
                    mb: 1,
                    "&:hover": { backgroundColor: "rgba(0, 23, 231, 0.04)" },
                  }}
                >
                  <Box sx={{ mr: 2, display: "flex", color: "#0017E7" }}>
                    <img src={notification_icon} alt="Notifications" />
                  </Box>
                  <ListItemText
                    primary={t("navBar.notifications")}
                    primaryTypographyProps={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                    }}
                  />
                  {totalNotifications !== 0 && (
                    <NotificationBadge count={totalNotifications} />
                  )}
                </ListItem>
              )}

              {/* Messages */}
              <ListItem
                button
                onClick={() => {
                  handleMenuItemClick("messages");
                  clearMessageNotifications();
                  toggleMobileMenu();
                }}
                sx={{
                  borderRadius: "8px",
                  mb: 1,
                  "&:hover": { backgroundColor: "rgba(0, 23, 231, 0.04)" },
                }}
              >
                <Box sx={{ mr: 2, display: "flex", color: "#0017E7" }}>
                  <img src={message_icon} alt="Messages" />
                </Box>
                <ListItemText
                  primary={t("navBar.messages")}
                  primaryTypographyProps={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                  }}
                />
                {messagenotification.length > 0 && (
                  <NotificationBadge count={messagenotification.length} />
                )}
              </ListItem>

              {/* Profile */}
              <ListItem
                button
                onClick={() => {
                  handleMenuItemClick(
                    userRole === "r" ? "talent_profile" : "profile"
                  );
                  toggleMobileMenu();
                }}
                sx={{
                  borderRadius: "8px",
                  mb: 1,
                  "&:hover": { backgroundColor: "rgba(0, 23, 231, 0.04)" },
                }}
              >
                <Box sx={{ mr: 2, display: "flex", color: "#0017E7" }}>
                  <img src={profile_icon} alt="Profile" />
                </Box>
                <ListItemText
                  primary={t("navBar.profile")}
                  primaryTypographyProps={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                  }}
                />
              </ListItem>

              {/* Saved Posts (hidden for recruiters) */}
              {userRole !== "r" && (
                <ListItem
                  button
                  onClick={() => {
                    handleMenuItemClick("saved");
                    toggleMobileMenu();
                  }}
                  sx={{
                    borderRadius: "8px",
                    mb: 1,
                    "&:hover": { backgroundColor: "rgba(0, 23, 231, 0.04)" },
                  }}
                >
                  <Box sx={{ mr: 2, display: "flex", color: "#0017E7" }}>
                    <img src={saved_posts_icon} alt="Saved Posts" />
                  </Box>
                  <ListItemText
                    primary={t("navBar.saved_posts")}
                    primaryTypographyProps={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                    }}
                  />
                </ListItem>
              )}

              {/* Posts Applied (hidden for recruiters) */}
              {userRole !== "r" && (
                <ListItem
                  button
                  onClick={() => {
                    handleMenuItemClick("applied");
                    toggleMobileMenu();
                  }}
                  sx={{
                    borderRadius: "8px",
                    mb: 1,
                    "&:hover": { backgroundColor: "rgba(0, 23, 231, 0.04)" },
                  }}
                >
                  <Box sx={{ mr: 2, display: "flex", color: "#0017E7" }}>
                    <img src={posts_applied_icon} alt="Posts Applied" />
                  </Box>
                  <ListItemText
                    primary={t("navBar.posts_applied")}
                    primaryTypographyProps={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                    }}
                  />
                </ListItem>
              )}

              {/* Logout */}
              <ListItem
                button
                onClick={() => {
                  handleMenuItemClick("logout");
                  toggleMobileMenu();
                }}
                sx={{
                  borderRadius: "8px",
                  mb: 1,
                  "&:hover": { backgroundColor: "rgba(255, 0, 0, 0.04)" },
                }}
              >
                <Box sx={{ mr: 2, display: "flex", color: "#FF0000" }}>
                  <img src={logout_icon} alt="Logout" />
                </Box>
                <ListItemText
                  primary={t("navBar.log_out")}
                  primaryTypographyProps={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    color: "#FF0000",
                  }}
                />
              </ListItem>
            </>
          )}
        </List>

        {/* Auth Buttons (if not logged in) */}
        {!userId.userId && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              mt: "auto",
            }}
          >
            <Button
              fullWidth
              onClick={() => {
                navigate("/company_register");
                toggleMobileMenu();
              }}
              sx={{
                border: "1px solid #0017E7",
                borderColor: "#0017E7",
                color: "#0017E7",
                fontFamily: "Poppins",
                textTransform: "none",
                fontWeight: 400,
                borderRadius: "11px",
                fontSize: 14,
                py: 1.5,
              }}
            >
              {t("navBar.sign_up_company")}
            </Button>
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                navigate("/login");
                toggleMobileMenu();
              }}
              sx={{
                color: "white",
                backgroundColor: "#0017E7",
                fontFamily: "Poppins",
                textTransform: "none",
                fontWeight: 400,
                borderRadius: "11px",
                fontSize: 14,
                py: 1.5,
              }}
            >
              {t("navBar.log_in")}
            </Button>
          </Box>
        )}
      </Box>
    </Drawer>
  );

  return (
    <AppBar position="static" color="transparent" elevation={0}>
      <Container
        disableGutters
        sx={{
          backgroundColor: "#F8F8F880",
          width: "100%",
          maxWidth: "100% !important",
          px: 3,
          py: 3,
        }}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            maxWidth: 1280,
            margin: "0 auto",
            width: "100%",
            px: 0,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
            <img
              src={new_logo}
              alt="Logo"
              onClick={() => navigate("/landing")}
              style={{ cursor: "pointer" }}
            />
            {!isMobile && (
              <Box
                sx={{ display: "flex", gap: 3, paddingTop: 1, paddingLeft: 5 }}
              >
                {/* {["/landing", "/jobs", "/spontaneous", "/joincaravan", "/"].map( */}
                {["/landing", "/jobs", "/spontaneous","/blogs", "/"].map(

                  (path) => (
                    <Box key={path} sx={{ position: "relative", pb: 0.5 }}>
                      <Box
                        onClick={() => navigate(path)}
                        sx={{
                          fontSize: 16,
                          textDecoration: "none",
                          color:
                            router.pathname === path ? "#0017E7" : "inherit",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          display: "inline-block",
                          cursor: "pointer",
                          "&:hover": {
                            color: "#0017E7",
                          },
                        }}
                      >
                        {path === "/landing" && t("navBar.home")}
                        {path === "/jobs" && t("navBar.jobs")}
                        {path === "/spontaneous" && t("navBar.spontaneous")}
                        {path === "/blogs" && t("navBar.blog")}
                        {path === "/joincaravan" && t("navBar.carnavals")}
                        {/* {path === "/" && t("navBar.help_center")} */}
                      </Box>
                      {router.pathname === path && (
                        <Box
                          sx={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            width: "50%",
                            height: "2px",
                            backgroundColor: "#0017E7",
                          }}
                        />
                      )}
                    </Box>
                  )
                )}
              </Box>
            )}
            {userRole === "r" && (
              <Button
                variant="contained"
                onClick={() =>
                  navigate("/talent/dashboard", {
                    state: { recruiter: true },
                  })
                }
                sx={{
                  backgroundColor: "#0017E7",
                  color: "white",
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  borderRadius: "10px",
                  padding: "8px 16px",
                  textTransform: "none",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#000DAD",
                    boxShadow: "0px 4px 10px rgba(0, 23, 231, 0.25)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                {t("navBar.recruiter_space")}
              </Button>
            )}
            {userRole === "s" && (
              <Button
                variant="contained"
                onClick={() => navigate("/superadmin/dashboard")}
                sx={{
                  backgroundColor: "#0017E7",
                  color: "white",
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  borderRadius: "10px",
                  padding: "8px 16px",
                  textTransform: "none",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#000DAD",
                    boxShadow: "0px 4px 10px rgba(0, 23, 231, 0.25)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                {t("navBar.super_admin_space")}
              </Button>
            )}
          </Box>
          {isMobile ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {userId.userId && userInfo && (
                <>
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontWeight: 600,
                      fontSize: "14px",
                      lineHeight: "21px",
                      color: colors.primary,
                      display: { xs: "none", sm: "block" },
                    }}
                  >
                    {userInfo.formData.first_name}
                  </Typography>
                  <Box sx={{ position: "relative" }}>
                    <ProfileScoreCircle
                      userId={userId.userId}
                      onClick={toggleMobileMenu}
                      size={36}
                      image={userInfo.formData.image}
                      fallbackText={userInfo.formData.first_name?.charAt(0)}
                    />
                    {/* Red dot indicator for unread notifications */}
                    {(storeUnreadNotifications.length > 0 ||
                      messagenotification.length > 0) && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: -2,
                            right: -2,
                            width: 10,
                            height: 10,
                            backgroundColor: "#FF0000",
                            borderRadius: "50%",
                            border: "2px solid white",
                            zIndex: 2,
                          }}
                        />
                      )}
                  </Box>
                </>
              )}
              {!userId.userId && (
                <IconButton onClick={toggleMobileMenu}>
                  <MenuIcon />
                </IconButton>
              )}
            </Box>
          ) : userId.userId != null ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 2,
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "21px",
                  color: colors.primary,
                }}
              >
                {userInfo.formData.first_name} {userInfo.formData.last_name}
              </Typography>

              {/* Avatar with notification indicator */}
              <Box sx={{ position: "relative" }}>
                <ProfileScoreCircle
                  userId={userId.userId}
                  onClick={handleAvatarClick}
                  size={44}
                  image={userInfo.formData.image}
                  fallbackText={userInfo.formData.first_name?.charAt(0)}
                  aria-controls={open ? "avatar-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                />

                {/* Red dot indicator for unread notifications */}
                {(storeUnreadNotifications.length > 0 ||
                  messagenotification.length > 0) && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: -2,
                        right: -2,
                        width: 12,
                        height: 12,
                        backgroundColor: "#FF0000",
                        borderRadius: "50%",
                        border: "2px solid white",
                        zIndex: 2,
                      }}
                    />
                  )}
              </Box>

              {/* Dropdown Menu */}
              {userId.userId && userInfo ? (
                <Menu
                  id="avatar-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "avatar-button",
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  PaperProps={{
                    sx: {
                      mt: 1.5,
                      width: 200,
                      borderRadius: "10px",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      "& .MuiList-root": {
                        py: 1,
                      },
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => handleMenuItemClick("notifications")}
                    sx={{
                      py: 2.5,
                      "&:hover": { backgroundColor: "rgba(0, 23, 231, 0.04)" },
                      display: userRole === "r" ? "none" : "flex",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          mr: 1.5,
                          display: "flex",
                          justifyContent: "center",
                          color: "#0017E7",
                        }}
                      >
                        <img src={notification_icon} style={{ width: 15, height: 15 }} />
                      </Box>
                      <MenuTypography>
                        {t("navBar.notifications")}
                      </MenuTypography>
                      {totalNotifications !== 0 && (
                        <NotificationBadge count={totalNotifications} />
                      )}
                    </Box>
                  </MenuItem>
                  <Divider
                    sx={{
                      borderTop: "1px solid #eee",
                      mx: 2,
                      display: userRole === "r" ? "none" : "block",
                    }}
                  />

                  <MenuItem
                    onClick={() => {
                      handleMenuItemClick("messages");
                      clearMessageNotifications(); // Reset message count when clicked
                    }}
                    sx={{
                      py: 2,
                      "&:hover": { backgroundColor: "rgba(0, 23, 231, 0.04)" },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          mr: 1.5,
                          display: "flex",
                          justifyContent: "center",
                          color: "#0017E7",
                        }}
                      >
                        <img src={message_icon} style={{ width: 15, height: 15 }} />
                      </Box>
                      <MenuTypography>{t("navBar.messages")}</MenuTypography>
                      {messagenotification.length > 0 && (
                        <NotificationBadge count={messagenotification.length} />
                      )}
                    </Box>
                  </MenuItem>
                  <Divider sx={{ borderTop: "1px solid #eee", mx: 2 }} />

                  <MenuItem
                    onClick={() =>
                      handleMenuItemClick(
                        userRole === "r" ? "talent_profile" : "profile"
                      )
                    }
                    sx={{
                      py: 2,
                      "&:hover": { backgroundColor: "rgba(0, 23, 231, 0.04)" },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        sx={{
                          mr: 1.5,
                          display: "flex",
                          justifyContent: "center",
                          color: "#0017E7",
                        }}
                      >
                        <img src={profile_icon} style={{ width: 15, height: 15 }} />
                      </Box>
                      <MenuTypography>{t("navBar.profile")}</MenuTypography>
                    </Box>
                  </MenuItem>
                  <Divider
                    sx={{
                      borderTop: "1px solid #eee",
                      mx: 2,
                      display: userRole === "r" ? "none" : "block",
                    }}
                  />

                  <MenuItem
                    onClick={() => handleMenuItemClick("saved")}
                    sx={{
                      py: 2,
                      "&:hover": { backgroundColor: "rgba(0, 23, 231, 0.04)" },
                      display: userRole === "r" ? "none" : "flex",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        sx={{
                          mr: 1.5,
                          display: "flex",
                          justifyContent: "center",
                          color: "#0017E7",
                        }}
                      >
                        <img src={saved_posts_icon} style={{ width: 15, height: 15 }} />
                      </Box>
                      <MenuTypography>{t("navBar.saved_posts")}</MenuTypography>
                    </Box>
                  </MenuItem>
                  <Divider
                    sx={{
                      borderTop: "1px solid #eee",
                      mx: 2,
                      display: userRole === "r" ? "none" : "block",
                    }}
                  />

                  <MenuItem
                    onClick={() => handleMenuItemClick("applied")}
                    sx={{
                      py: 2,
                      "&:hover": { backgroundColor: "rgba(0, 23, 231, 0.04)" },
                      display: userRole === "r" ? "none" : "flex",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        sx={{
                          mr: 1.5,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "#0017E7",
                        }}
                      >
                        <img src={posts_applied_icon} style={{ width: 15, height: 15 }} />
                      </Box>
                      <MenuTypography>
                        {t("navBar.posts_applied")}
                      </MenuTypography>
                    </Box>
                  </MenuItem>
                  <Divider sx={{ borderTop: "1px solid #eee", mx: 2 }} />
                  <Box>
                    <MenuItem
                      onClick={() => handleMenuItemClick("logout")}
                      sx={{
                        py: 2,
                        "&:hover": { backgroundColor: "rgba(255, 0, 0, 0.04)" },
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box
                          sx={{
                            mr: 1.5,
                            display: "flex",
                            justifyContent: "center",
                            color: "#FF0000",
                          }}
                        >
                          <img src={logout_icon} style={{ width: 15, height: 15 }} />
                        </Box>
                        <Typography
                          sx={{
                            fontFamily: "Poppins",
                            fontSize: 14,
                            fontWeight: 500,
                            color: "#FF0000",
                          }}
                        >
                          {t("navBar.log_out")}
                        </Typography>
                      </Box>
                    </MenuItem>
                  </Box>
                </Menu>
              ) : (
                <Skeleton variant="circular" width={40} height={40} />
              )}
            </Box>
          ) : (
            <Box sx={{ display: "flex", gap: 2 }}>
              {/* FIX: */}
              <Tooltip
                title={t("navBar.sign_up_company_tooltip")}
                arrow
                placement="bottom-start"
                enterDelay={200}
                leaveDelay={100}
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: '#ffffff',
                      color: '#1e293b',
                      fontSize: '13px',
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: 400,
                      padding: '12px 16px',
                      borderRadius: '10px',
                      border: '1px solid rgba(0, 23, 231, 0.12)',
                      boxShadow: '0 4px 20px rgba(0, 23, 231, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06)',
                      maxWidth: 260,
                      lineHeight: 1.5,
                      position: 'relative',
                      overflow: 'hidden',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        width: '3px',
                        background: '#0017E7',
                        borderRadius: '3px 0 0 3px',
                      },
                    },
                  },
                  arrow: {
                    sx: {
                      color: '#ffffff',
                      '&::before': {
                        border: '1px solid rgba(0, 23, 231, 0.12)',
                        backgroundColor: '#ffffff',
                      },
                    },
                  },
                }}
                TransitionProps={{
                  timeout: { enter: 250, exit: 150 },
                }}
              >
                <Button
                  fullWidth
                  onClick={() =>
                    navigate("/company_register")
                  }
                  sx={{
                    border: "1px solid #0017E7 ",
                    borderColor: "#0017E7",
                    color: "#0017E7",
                    height: 50,
                    width: 106,
                    fontFamily: "Poppins",
                    textTransform: "none",
                    fontWeight: 400,
                    borderRadius: "11px",
                    fontSize: 14,
                  }}
                >
                  {t("navBar.sign_up_company")}
                </Button>
              </Tooltip>
              <Tooltip
                title={t("navBar.log_in")}
                arrow
                placement="bottom-start"
                enterDelay={200}
                leaveDelay={100}
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: '#ffffff',
                      color: '#1e293b',
                      fontSize: '13px',
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: 400,
                      padding: '12px 16px',
                      borderRadius: '10px',
                      border: '1px solid rgba(0, 23, 231, 0.12)',
                      boxShadow: '0 4px 20px rgba(0, 23, 231, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06)',
                      maxWidth: 260,
                      lineHeight: 1.5,
                      position: 'relative',
                      overflow: 'hidden',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        width: '3px',
                        background: '#0017E7',
                        borderRadius: '3px 0 0 3px',
                      },
                    },
                  },
                  arrow: {
                    sx: {
                      color: '#ffffff',
                      '&::before': {
                        border: '1px solid rgba(0, 23, 231, 0.12)',
                        backgroundColor: '#ffffff',
                      },
                    },
                  },
                }}
                TransitionProps={{
                  timeout: { enter: 250, exit: 150 },
                }}
              >
              <Button
                onClick={() => navigate("/login")}
                variant="contained"
                sx={{
                  color: "white",
                  backgroundColor: "#0017E7",
                  // height: 50,
                  // width: 111,
                  fontFamily: "Poppins",
                  textTransform: "none",
                  fontWeight: 400,
                  borderRadius: "11px",
                  fontSize: 14,
                  whiteSpace: 'nowrap'
                }}
              >
                {/* {t("navBar.log_in")} */}
                <img src={login_icon} alt="Login" style={{ width: 25, height: 25 }} />
              </Button>
              </Tooltip>
            </Box>
          )}
        </Toolbar>
      </Container>
      <MobileMenu />
      <WebSocketStatus />
    </AppBar>
  );
}

export default NewAppBar;
